export enum ResultType {
  Maintenance,
  LoseWeight,
  GainWeight
}
